export default __webpack_public_path__ + "static/media/swl_breakout.3f2382de.png";